import _Avatar from "@arco-design/web-react/es/Avatar";
import _Grid from "@arco-design/web-react/es/Grid";
import _Table from "@arco-design/web-react/es/Table";
import _Typography from "@arco-design/web-react/es/Typography";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import style from './style.less';
import useLocale from '@src/hooks/useLocale';
import { formatDate } from '@src/utils/format';
var renderValue = function renderValue(val) {
  return /*#__PURE__*/React.createElement(_Typography.Text, {
    style: {
      margin: 0
    },
    ellipsis: {
      cssEllipsis: true,
      showTooltip: true
    }
  }, val || '-');
};
var DiffTokenTable = function DiffTokenTable(props) {
  var data = props.data;
  var lang = useLocale().lang;
  var isZh = lang === 'zh-CN';
  return /*#__PURE__*/React.createElement(_Table, __assign({
    border: false,
    className: style['diff-token-table'],
    size: "small",
    scroll: {
      x: true
    },
    pagination: {
      pageSize: 10,
      showTotal: true,
      hideOnSinglePage: true
    },
    data: data
  }, props.tableProps, {
    rowKey: "_id",
    columns: __spreadArray([{
      title: isZh ? '组件' : 'component',
      dataIndex: 'component',
      width: 120,
      render: renderValue
    }, {
      title: isZh ? '变量名' : 'Variables',
      dataIndex: 'key',
      width: 200,
      render: function render(v) {
        return renderValue(v || '自定义样式');
      }
    }, {
      title: isZh ? '当前值' : 'Current value',
      dataIndex: 'value',
      width: 140,
      render: function render(v, row) {
        return renderValue(v || row.code);
      }
    }, {
      title: isZh ? '旧值' : 'Previous value',
      dataIndex: 'prevValue',
      width: 140,
      render: function render(v, row) {
        return renderValue(v || row.prevCode);
      }
    }, {
      title: isZh ? '更新时间' : 'Updated time',
      dataIndex: 'updatedAt',
      width: 160,
      render: function render(v) {
        return formatDate(v, 'YYYY-MM-DD HH:MM:ss');
      }
    }, {
      title: isZh ? '操作人' : 'Operator',
      dataIndex: 'operator',
      width: 140,
      render: function render(v, record) {
        return record.userInfo ? /*#__PURE__*/React.createElement(_Grid.Row, {
          align: "center"
        }, /*#__PURE__*/React.createElement(_Avatar, {
          size: 16,
          style: {
            marginRight: 8
          }
        }, /*#__PURE__*/React.createElement("img", {
          src: record.userInfo.avatar_url
        })), /*#__PURE__*/React.createElement("span", null, record.userInfo.name)) : renderValue(v);
      }
    }], __read(props.operationColumns || []), false)
  }));
};
export default DiffTokenTable;